import { LocalDate } from 'js-joda';
import _ from 'lodash';

import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { DeliveryAssignmentRequest } = protos;

export interface CheckinActions {
  changeCheckinDate(date: LocalDate): Promise<BaseTockAction>;
}

export function changeDeliveryDate(date: LocalDate): Promise<BaseTockAction> {
  return Promise.resolve({
    type: AppConstants.DELIVERY_DATE_CHANGE,
    payload: date,
  });
}

/**
 * Assigns the passed in deliveryParty to the given patron
 * @param deliveryParty
 */
export function assignDelivery(visitId: number, patronId: string): ApiAction {
  const request = DeliveryAssignmentRequest.fromObject({
    visitId,
    patronId: _.isEmpty(patronId) ? undefined : patronId,
  });
  return {
    TockApi: {
      postProto: '/delivery/driver/assign',
      type: AppConstants.ASSIGN_DELIVERY,
      request,
      toast: 'Delivery assigned',
    },
  };
}
